import {useState, useEffect, useContext} from 'react';
import TableForDesktopAndMobile from '../../UI/TableForDesktopAndMobile';
import {Context} from '../../../context';
import {
  getDateString,
  dollarAmount,
  getAccountBalanceInDollars
} from '../../../helperFunctions';
import getAccountReportInfo from './getAccountReport';

function AccountReportPdf() {
  const {account, localeText, getTicketName} = useContext(Context);

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const startDate = urlParams.get('start-date');
  const endDate = urlParams.get('end-date');
  const [orderHistory, setOrderHistory] = useState([]);
  const [scans, setScans] = useState([]);

  useEffect(() => {
    const {orderHistory, scans} = getAccountReportInfo({
      startDate,
      endDate,
      account
    });
    setOrderHistory(orderHistory);
    setScans(scans);
  }, []);

  return (
    <div>
      <h1 className='font-bold'>
        {localeText('rw_header_account_report', 'Account Report')}
      </h1>
      <table className='font-bold'>
        <tbody>
          <tr>
            <td className='pr-8'>
              {localeText('rw_title_account', 'Account')}
            </td>
            <td>{account.profile.email}</td>
          </tr>
          <tr>
            <td className='pr-8'>
              {localeText('rw_title_ending_balance', 'Ending Balance')}
            </td>
            <td>${getAccountBalanceInDollars(account)}</td>
          </tr>
        </tbody>
      </table>
      <h2 className='font-bold mb-2'>
        {localeText('rw_title_orders', 'Orders')}
      </h2>
      <div className='border border-black p-4'>
        <TableForDesktopAndMobile
          id='orders'
          properties={[
            {
              title: localeText('rw_title_date', 'Date'),
              value: tableItem => getDateString(tableItem.dateTime)
            },
            {
              title: localeText('rw_title_order_number', 'Order Number'),
              value: tableItem => tableItem.orderId
            },
            {
              title: localeText('rw_title_description', 'Description'),
              value: tableItem => getTicketName(tableItem.productId)
            },
            {
              title: localeText('rw_title_amount', 'Amount'),
              value: tableItem => dollarAmount(tableItem.amount)
            },
            {
              title: localeText('rw_title_payment_method', 'Payment Method'),
              value: tableItem =>
                tableItem.cardType && tableItem.cardNumber
                  ? `${tableItem.cardType.replace('Credit', '')} ****${
                      tableItem.cardNumber
                    }`
                  : ''
            }
          ]}
          tableItems={orderHistory}
        />
      </div>
      <h2 className='font-bold mb-2'>
        {localeText('rw_title_card_transactions', 'Transactions')}
      </h2>
      <div className='border border-black p-4'>
        <TableForDesktopAndMobile
          id='transactions'
          properties={[
            {
              title: localeText('rw_title_date', 'Date'),
              value: tableItem => getDateString(tableItem.created)
            },
            {
              title: localeText('rw_title_order_number', 'Order Number'),
              value: tableItem => (tableItem.orderId ? tableItem.orderId : '')
            },
            {
              title: localeText('rw_title_tap', 'Tap'),
              value: tableItem => getTicketName(tableItem.productId)
            },
            {
              title: localeText(
                'rw_title_stored_value_amount',
                'Stored Value Amount'
              ), // TODO add the phrase data
              value: tableItem =>
                tableItem.tripCost ? dollarAmount(tableItem.tripCost) : ''
            },
            {
              title: localeText('rw_title_location', 'Location'),
              value: tableItem => tableItem.stationName
            },
            {
              title: localeText('rw_title_card', 'Card'),
              value: tableItem =>
                `${tableItem.nickname ? tableItem.nickname : ''} ${
                  tableItem.cardNumber ? tableItem.cardNumber : ''
                }`
            }
          ]}
          tableItems={scans}
        />
      </div>
    </div>
  );
}

export default AccountReportPdf;
